import CustomButton from 'components/CustomInput/Button';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';
import React, { useState } from 'react';
import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import { useSelector } from 'react-redux';
import { REJECT_CONFIRM } from 'utility/frontendMessage';

const useUserApprovalData = (props) => {
    const { setWarningMsg } = props;
    const showCommentDialog = useCommentDialog();
    const systemMessage = useSelector((state) => state.systemMessage.systemMessage);

    const [row, setRow] = useState([]);

    const rawColumn = [
        { field: 'email', headerName: 'Email', width: 150 },
        { field: 'title', headerName: 'Title', width: 150 },
        { field: 'firstName', headerName: 'First Name', width: 100 },
        { field: 'surname', headerName: 'Surname', width: 100 },
        { field: 'institution', headerName: 'Hospital / Institution', width: 150 },
        { field: 'justification', headerName: 'Justifications', width: 250 },
        { field: 'contact', headerName: 'Contact Number', width: 150 },
        {
            field: 'action',
            headerName: 'Action',
            width: 200,
            renderCell: (params) => {
                return (
                    <div>
                        <CustomButton onClick={() => approvePendingApprovalUser(params.row)}>Approve</CustomButton>
                        <CustomButton style={{ marginLeft: 10 }} onClick={() => handleReject(params.row)}>
                            Reject
                        </CustomButton>
                    </div>
                );
            },
        },
    ];

    const getPendingApprovalUser = () => {
        setGlobalLoading(true);
        API.user
            .getPendingApprovalUser()
            .then((res) => {
                setRow(res.data?.result);
            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    const approvePendingApprovalUser = (row) => {
        setGlobalLoading(true);
        API.user
            .approveEmailAccount({
                id: row.id,
                decision: 1,
                email: row.email,
                workflowId: row.workflowId,
            })
            .then((res) => {
                getPendingApprovalUser();
                setWarningMsg({
                    type: 'success',
                    message: systemMessage.approvePendingApprovalUserSuccess,
                    footerActions: [
                        {
                            label: 'Confirm',
                            clicked: () => {
                                setWarningMsg(null);
                            },
                        },
                    ],
                });
            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    const handleReject = async (row) => {
        const { submit, comment } = await showCommentDialog({
            title: REJECT_CONFIRM,
            description: '',
            placeholder: 'Please state the reason(s).',
        });
        if (submit) {
            rejectPendingApprovalUser(row, comment);
        }
    };

    const rejectPendingApprovalUser = (row, comment) => {
        setGlobalLoading(true);
        API.user
            .approveEmailAccount({
                id: row.id,
                decision: 2,
                email: row.email,
                reason: comment,
                workflowId: row.workflowId,
            })
            .then((res) => {
                getPendingApprovalUser();
                setWarningMsg({
                    type: 'success',
                    message: systemMessage.rejectPendingApprovalUserSuccess,
                    footerActions: [
                        {
                            label: 'Confirm',
                            clicked: () => {
                                setWarningMsg(null);
                            },
                        },
                    ],
                });
            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    return {
        columns: rawColumn,
        rawColumn: rawColumn,
        rows: row,
        getPendingApprovalUser,
        approvePendingApprovalUser,
        rejectPendingApprovalUser,
    };
};

export default useUserApprovalData;
